<!-- eslint-disable vue/multi-word-component-names -->
<template>
  <div class="pagination d-flex align-items-center">
    <BaseButton
      v-if="activePage > 1"
      variant="naked"
      class="reset-btn-styling"
      data-testid="prev-page-btn"
      aria-label="Vorige pagina"
      @click="onPageChange(activePage - 1)"
    >
      <ChevronLeftIcon width="6.93px" height="12.8px" />
    </BaseButton>

    <div class="desktop-pagination d-none d-md-flex">
      <PaginationItem
        v-for="(item, index) in getPages()"
        :key="index"
        :item="item"
        :active-page="activePage"
        :on-page-change="onPageChange"
      />
    </div>

    <div class="mobile-pagination d-flex d-md-none">
      <PaginationItem
        v-for="(item, index) in getPages(true)"
        :key="index"
        :item="item"
        :active-page="activePage"
        :on-page-change="onPageChange"
      />
    </div>

    <BaseButton
      v-if="activePage < totalPages"
      variant="naked"
      class="reset-btn-styling"
      data-testid="next-page-btn"
      aria-label="Volgende pagina"
      @click="onPageChange(activePage + 1)"
    >
      <ChevronRightIcon width="6.93px" height="12.8px" />
    </BaseButton>
  </div>
</template>

<script>
import PaginationItem from '~/components/pagination/PaginationItem'
import ChevronLeftIcon from '~/assets/icons/chevron-left.svg'
import ChevronRightIcon from '~/assets/icons/chevron-right.svg'

export default {
  components: {
    PaginationItem,
    ChevronLeftIcon,
    ChevronRightIcon,
  },
  props: {
    totalPages: {
      type: Number,
      required: true,
    },
    currentPage: {
      type: Number,
      default: 1,
    },
  },
  emits: ['pageChanged'],
  data() {
    return {
      activePage: this.currentPage,
    }
  },
  watch: {
    currentPage(page) {
      if (page !== this.activePage) {
        this.activePage = page
      }
    },
  },
  methods: {
    populateBaseItems(items, maxPages) {
      for (let i = 0; i < Math.min(maxPages, this.totalPages); i++) {
        items.push(i + 1)
      }
    },
    setLastPage(items) {
      items[items.length - 1] = this.totalPages
    },
    setDots(data) {
      if (data.showBeginningDots) {
        data.items[1] = '...'
      }

      if (data.showEndDots) {
        data.items[data.maxPages - 2] = '...'
      }
    },
    setCenterItems(items, pageOffset, mobile) {
      items[pageOffset] = this.activePage

      if (!mobile) {
        items[2] = this.activePage - 1
        items[4] = this.activePage + 1
      }
    },
    setLastItems(items, maxPages) {
      for (let i = 0; i < maxPages - 2; i++) {
        items[maxPages - 1 - i] = this.totalPages - i
      }
    },
    getPages(mobile) {
      const maxPages = mobile ? 5 : 7
      const pageOffset = mobile ? 2 : 3

      const longerPagination = this.totalPages > maxPages
      const showBeginningDots =
        longerPagination && this.activePage > maxPages - pageOffset
      const showEndDots =
        longerPagination && this.activePage < this.totalPages - pageOffset

      const items = []

      this.populateBaseItems(items, maxPages)
      this.setLastPage(items)
      this.setDots({ items, showBeginningDots, showEndDots, maxPages })

      if (showBeginningDots && showEndDots) {
        this.setCenterItems(items, pageOffset, mobile)
      }

      if (showBeginningDots && !showEndDots) {
        this.setLastItems(items, maxPages)
      }

      return items
    },
    onPageChange(page) {
      this.activePage = page
      this.$emit('pageChanged', page)
    },
  },
}
</script>

<style lang="scss" scoped>
button {
  padding: 8px 16px;
  height: 41px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: $font-size-base;
  font-weight: normal;
  line-height: 24px;
  border-bottom: 1px solid $grey-02;
  border-radius: 0%;

  &.selected {
    cursor: default !important;
    font-weight: $font-weight-semibold;
    color: $bc-green;
    padding-bottom: 7px;
    border-bottom: 2px solid $bc-green;
  }

  &:not(.selected):hover {
    color: $bc-green;
    background-color: rgba($bc-green, 0.2);

    svg {
      fill: $bc-green;
    }
  }

  &:disabled {
    color: $black !important;
    background-color: inherit;
    border-color: $grey-02;
  }
}

svg {
  margin-bottom: 2px;
  fill: $black;
}
</style>
